import Vue from "vue";
import filters from "@/filters";

Vue.use(filters);
